module.exports = __webpack_public_path__ + "static/media/About_sq.c7fe0b5b.md";